import { combineReducers } from '@reduxjs/toolkit';
import { authReducer } from '../../features/auth';
import { driveReducer } from '../../features/drive';
import { companyReducer } from '../../features/company';
import { collectionReducer } from '../../features/collection';
import { userReducer } from '../../features/user';
import { default as stateReducer } from '../../utils/common/store/state.slice';
import { default as roleReducer } from '../../utils/common/store/role.slice';
import { default as companyTypeReducer } from '../../utils/common/store/companyType.slice';
import { dashboardReducer } from '../../features/dashboard';
import { mileReducer } from '../../features/mileMarker';
import { laneReducer } from '../../features/lane';
import { railsReducer } from '../../features/rails';

const rootReducer = combineReducers({
  auth: authReducer,
  drive: driveReducer,
  company: companyReducer,
  collection: collectionReducer,
  user: userReducer,
  states: stateReducer,
  role: roleReducer,
  companyType: companyTypeReducer,
  dashboard: dashboardReducer,
  mile: mileReducer,
  lane: laneReducer,
  rails: railsReducer,
});

export default rootReducer;
